import { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Menu } from "lucide-react";
import { cn } from "@/lib/utils";
import { themeStore } from "@/stores";
import { ThemeSwitcher } from "@/components/layout";
import { LanguageSwitcher } from "@/components/common";
import { NotificationsBell } from "@/features/notifications";
import UserMenu from "./UserMenu";

const Navbar = observer(({ sidebarCollapsed, onMobileMenuToggle }) => {
  const [elevated, setElevated] = useState(false);
  const theme = themeStore.theme;

  // Add shadow on scroll
  useEffect(() => {
    const onScroll = () => setElevated(window.scrollY > 2);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Theme-based classes
  const baseBg = "bg-card";
  const backdrop = "backdrop-blur supports-[backdrop-filter]:backdrop-blur-md";
  const borderClr = "border-border";
  const shadow = elevated ? "shadow-sm" : "";

  return (
    <header
      className={cn(
        "sticky top-0 z-40 border-b transition-shadow",
        baseBg,
        backdrop,
        borderClr,
        shadow,
      )}
      data-sidebar-state={sidebarCollapsed ? "collapsed" : "expanded"}
    >
      <div className="relative mx-auto flex h-14 w-full items-center justify-between px-4 lg:px-8">
        {/* Left: Hamburger for mobile */}
        <div className="flex items-center gap-4">
          <button
            className="rounded-radius p-2 focus:outline-none lg:hidden"
            onClick={onMobileMenuToggle}
            aria-label="Toggle mobile menu"
          >
            <Menu className="h-6 w-6" />
          </button>

          {/* Show brand only when sidebar is collapsed on desktop */}
          {sidebarCollapsed && (
            <div className="hidden lg:flex items-center">
              <img
                src="/logos/logo.svg"
                alt="NxStart"
                className="h-12 w-auto"
              />
            </div>
          )}
        </div>

        {/* Right: Menus */}
        <div className="flex flex-none items-center gap-2">
          <LanguageSwitcher />
          <ThemeSwitcher />
          <NotificationsBell />
          <UserMenu />
        </div>
      </div>
    </header>
  );
});

export default Navbar;
